import type { Auth0User } from '@/types/Auth0User'

export const getAbbreviationFromUser = (user: Auth0User): string => {
  if (user.nickname) {
    const nameSplit = user.nickname.split(/[\s-.]+/g)
    if (nameSplit.length > 1) {
      return nameSplit[0].substring(0, 1).toUpperCase() + nameSplit[1].substring(0, 1).toUpperCase()
    }
    return nameSplit[0].substring(0, 1).toUpperCase()
  }

  return '??'
}
